<span [ngSwitch]="id">
  <span class="badge order-prepared" *ngSwitchCase="1"> {{'packStatusValue.'+id | translate}} </span>
  <span class="badge order-canceled" *ngSwitchCase="2"> {{'packStatusValue.'+id | translate}} </span>
  <span class="badge order-in-service" *ngSwitchCase="3"> {{'packStatusValue.'+id | translate}}</span>
  <span class="badge order-delivered" *ngSwitchCase="4"> {{'packStatusValue.'+id | translate}}</span>
  <span class="badge order-product-preparation" *ngSwitchDefault> {{'packStatusValue.'+id | translate}}</span>
</span>